import { render, staticRenderFns } from "./DistributionAccountManagement.vue?vue&type=template&id=08f7018e&scoped=true"
import script from "./DistributionAccountManagement.vue?vue&type=script&lang=js"
export * from "./DistributionAccountManagement.vue?vue&type=script&lang=js"
import style0 from "./DistributionAccountManagement.vue?vue&type=style&index=0&id=08f7018e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08f7018e",
  null
  
)

export default component.exports